import { lazy, Suspense, useEffect, useState, useTransition, useLayoutEffect } from 'react';
import LoaderComponent from '@components/atom/layout/loader';
import Login from '@pages/auth/login';
import SignUp from '@pages/auth/signUp';
import { Navigate, Route, Routes, useNavigate, useLocation } from 'react-router-dom';
import AppRoutes from './appRoutes';
import { RootState, AppDispatch } from '@reducers/index';
import { useDispatch, useSelector } from 'react-redux';
import LayoutWrapper from '@components/atom/layout/layoutWrapper';
import AsoRoutes from './asoRoutes';
import KeywordRoutes from './keywordRoutes';
import RankingRoutes from './rankingRoutes';
import AccountRoutes from './accountRoutes';
import AppManagerRoutes from './appManager';
import AccountSettingsRoutes from './accountSettings';
import SignUpForm from '@pages/auth/signUpForm';
import SignUpVerification from '@pages/auth/signUpVerification';
import SignUpLink from '@pages/auth/signUpLink';
import Welcome from '@pages/auth/welcome';
import AlertSetting from '@pages/alertSetting/alertSetting';

import * as layoutThunk from '@reducers/layout/layoutThunk';
import { layoutActions } from '@reducers/layout/layoutSlice';
import { getLanguageCode } from '@utils/common/language';

//const AuthorizedRoutes = lazy(() => import('./authorizedRoutes'));
const MainRoute: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isPending, startTransition] = useTransition();
  const dispatch = useDispatch<AppDispatch>();
  const { myAppList, selectedAppInfo, myAppObj, headerSearchedAppInfo } = useSelector(
    (state: RootState) => state.LAYOUT
  );

  const { userInfo } = useSelector(({ auth }: RootState) => auth);

  useLayoutEffect(() => {
    if (userInfo) {
      const { userId, subAccount } = userInfo;
      if (subAccount?.length > 0) {
        startTransition(() => {
          if (myAppList.length === 0) {
            //my app request
            dispatch(layoutThunk.getMyAppsThunk())
              .unwrap()
              .then((success) => {
                console.log('success: ', success);
                if (success.length === 0) {
                  //my app 등록이 안된 상태이면, my app 등록 화면으로 이관.
                  navigate('/appManager/myApps');
                } else if (success.length > 0) {
                  // 국가 및 언어 설정 (초기앱을 받은 상태에서 국가 및 언어는 초기에 맞게 설정)
                  dispatch(layoutActions.setCountryFlag(success[0]?.country.toUpperCase()));
                  dispatch(layoutActions.setLanguage(getLanguageCode(success[0]?.country.toUpperCase())));
                }
              })
              .catch((err) => {
                console.log('layoutThunk.getMyAppsThunk() Error Occur: ', err);
                navigate('/appManager/myApps');
              });
          }
        });
      } else {
        navigate('/manager/account/teamManager');
      }
    }
  }, [userInfo]);

  // headerSearchedAppInfo 이부분로직 짜기
  // 1. headerSearchedAppInfo 나 myAppInfo 가 바뀔때마다 각 컴포넌트에 바뀐값이 들어간다.
  // 2. headerSearchedAppInfo 가 최우선 순위이다.
  // 3. headerSearchedAppInfo 가 없을때 myAppInfo 값이 들어간다.
  // 4. myAppInfo 은 오른 상단 MyAccount 에서 subAccount의 팀 클릭시 변화한다.
  useEffect(() => {
    if (!!headerSearchedAppInfo) {
      dispatch(layoutActions.setSelectedAppInfo({ ...headerSearchedAppInfo, selectedAppType: 'SEARCH' }));
      return;
    } else if (!!myAppObj) {
      dispatch(layoutActions.setSelectedAppInfo({ ...myAppObj, selectedAppType: 'MYAPP' }));
      return;
    }
  }, [myAppObj, headerSearchedAppInfo]);

  // // 주소기반으로 myAppObj 체크하여 null 일때 navigate('/appManager/myApps'); 처리
  // // 아래 주석은 사용할 것임. (AIX 에 물어본 후 결정하기)
  // useEffect(() => {
  //   console.log('location: ', location);
  //   console.log('myAppObj: ', myAppObj);
  //   if (!myAppObj) {
  //     navigate('/appManager/myApps');
  //   }
  // }, [location]);

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<SignUp />} />
      <Route path="/signupform" element={<SignUpForm />} />
      <Route path="/signupvarification" element={<SignUpVerification />} />
      <Route path="/signuplink" element={<SignUpLink />} />
      <Route path="/welcome" element={<Welcome />} />
      <Route element={<LayoutWrapper />}>
        <Route path="/app/*" element={<AppRoutes />} />
        <Route path="/aso/*" element={<AsoRoutes />} />
        <Route path="/keyword/*" element={<KeywordRoutes />} />
        <Route path="/ranking/*" element={<RankingRoutes />} />
        <Route path="/appManager/*" element={<AppManagerRoutes />} />
        <Route path="/accountSettings/*" element={<AccountSettingsRoutes />} />
        <Route path="/alertSetting" element={<AlertSetting />} />
        {/* 일단 아래의 건 lefeMenu 폴더의 index.tsx 와 디비에서 불러오는 부분까지 수정할수도
        아니면 아예 삭제할 수 있는 부분입 */}
        <Route path="/manager/account/*" element={<AccountRoutes />} />
        <Route path="*" element={userInfo ? <Navigate to={'/app/profile'} /> : <Navigate to={'/login'} />} />
      </Route>
    </Routes>
  );
};

export default MainRoute;
